<ng-template #forumForm let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <div class="d-flex justify-content-between">
      <h2 class="title">Start New Topic</h2>
      <div class="form-group">
        <label for="limitLevel">Limit Level</label>
        <select id="limitLevel" class="form-control" [(ngModel)]="forum.limitLevelValue">
          <option [ngValue]="0">No Level</option>
          <option [ngValue]="1">Level 1</option>
          <option [ngValue]="2">Level 2</option>
          <option [ngValue]="3">Level 3</option>
          <option [ngValue]="4">Level 4</option>
          <option [ngValue]="5">Level 5</option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <label class="mb-0" for="">Title</label>
      <input type="text" [(ngModel)]="forum.titleValue" class="form-control" />
    </div>
    <div class="form-group">
      <label class="mb-0" for="">Message</label>

      <app-editor [(innerValue)]="forum.messageValue"></app-editor>
    </div>
    <div class="form-group">
      <label class="mb-0" for="">Category</label>
      <select [(ngModel)]="forum.categoryValue" ngDefaultControl class="form-control">
        <option [value]="row" *ngFor="let row of mainCategories">
          {{ row }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label class="mb-0" for="">Tags</label>

      <select2 [data]="categoriesSelect" [multiple]="true" [displaySearchStatus]="always" ngDefaultControl
        [ngModel]="forum.tagValue" (ngModelChange)="forum.tagValue = $event"> </select2>
    </div>
    <div class="form-group" *ngIf="roleSer?.roles?.userType.includes('ADMIN')">
      <label class="mb-0" for="">Metadata</label>
      <textarea class="form-control" [(ngModel)]="forum.metadata"></textarea>
    </div>
    <!-- <div class="d-flex" *ngFor="let image of forum?.images; let i = index">
      <img loading="lazy" src="{{ image.filePreview }}" class="img-thumbnail mr-2" style="height: 80px" alt="" />
      <div class="form-group w-100">
        <label for="">Image {{ i + 1 }}</label>
        <div class="d-flex">
          <input type="file" class="form-control" (change)="onImageChange($event, image)" [ngModelOptions]="{ standalone: true }" />
          <button class="btn btn-danger btn-sm ml-2" (click)="removeImage(i)">
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>
      </div>
    </div> -->
    <div class="row row-cols-3">
      <div class="col mb-2" *ngFor="let image of forum?.images; let i = index">
        <div class="upload-image">
          <button class="btn btn-danger btn-delete btn-sm ml-2" (click)="removeImage(i)">
            <i class="fa-solid fa-trash"></i>
          </button>
          <input type="file" accept="image/*" (change)="onFileSelected($event, image)" />
          <img loading="lazy" *ngIf="image.filePreview"
            [src]="image.filePreview.includes('public/') ? imgUrl + image.filePreview : image.filePreview" alt="
            Thumbnail Preview" (error)="commonService.handleError($event)" />
          <div *ngIf="!image.filePreview">
            <svg viewBox="0 0 700 662" fill="none">
              <path
                d="M122.187 122.422C96.5625 148.047 79.1406 179.609 71.25 214.063H84.1406C98.8281 155.234 142.812 107.891 199.766 88.5156V75.3125C170.781 84.375 144.297 100.312 122.187 122.422Z"
                fill="var(--primary)" />
              <path
                d="M699.844 353.203C699.844 441.953 627.891 513.984 539.141 514.062H411.563V479.688H539.141C572.891 479.688 604.609 466.484 628.438 442.656C652.344 418.75 665.469 387.031 665.469 353.203C665.469 319.453 652.344 287.656 628.438 263.828C604.531 240 572.734 226.797 538.984 226.797C530 226.797 521.172 227.734 512.578 229.531C500.859 232.031 489.609 236.094 479.141 241.797C478.359 229.766 476.562 217.813 473.828 206.172V206.094C471.016 193.906 467.109 182.031 462.188 170.391C450.938 143.906 434.922 120.078 414.453 99.6094C393.984 79.1406 370.234 63.125 343.672 51.875C316.25 40.3125 287.109 34.375 257.031 34.375C226.953 34.375 197.813 40.2344 170.391 51.875C143.906 63.0469 120.078 79.1406 99.6094 99.6094C79.1406 120.078 63.125 143.906 51.875 170.391C40.2344 197.812 34.375 226.953 34.375 257.031C34.375 287.109 40.2344 316.25 51.875 343.672C63.0469 370.156 79.1406 393.984 99.6094 414.453C120.078 434.922 143.906 450.937 170.391 462.187C197.813 473.75 226.953 479.688 257.031 479.688H288.047V514.062H256.016C114.531 513.516 0 398.672 0 257.031C0 115.078 115.078 0 257.031 0C377.813 0 479.141 83.2813 506.641 195.547V195.625C517.109 193.516 527.891 192.344 538.984 192.344C627.813 192.422 699.844 264.375 699.844 353.203Z"
                fill="#39393A" />
              <path
                d="M491.25 427.656H473.594L356.016 310.078V661.328H343.516V310.234L226.016 427.656H208.359L349.766 286.25L491.25 427.656Z"
                fill="var(--primary)" />
            </svg>
            <div>Please select a file to upload.</div>
          </div>
        </div>
      </div>
    </div>
    <button class="my-button-3 secondary mt-2" type="button" (click)="handleAddImage()"><i class="fa-solid fa-plus"></i>
      Add File</button>
  </div>
  <div class="modal-footer">
    <button class="my-button-3 error" [disabled]="forum?.hasSubmit" (click)="modalService.dismissAll()"><i
        class="fa-solid fa-times"></i> Cancel</button>
    <button class="my-button-3" (click)="forumStore()" [disabled]="forum?.hasSubmit"><i
        class="fa-solid fa-paper-plane"></i> Submit</button>
  </div>
</ng-template>